// VARIOUS
export const RECORDS_PER_PAGE = 25;

// Tips and Tricks Data Types
export const TTdataTypes = ["video", "iframe", "url"];

// STRING MANIPULATION
export const toTitleCase = (str) => {
	if (!str) return "";
	if (str === "it") return "IT";

	return str.replace(/\w\S*/g, function (txt) {
		const word = txt.toLowerCase().includes("bqe")
			? txt.replace(/bqe/gi, "BQE")
			: txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();

		return word;
	});
};

// BQE
export const generateAlphanumericCode = () => {
	// Generates a 5-character alphanumeric code, generates an integer then converts to ASCII
	var code = "";

	for (let i = 0; i < 5; i++) {
		// Randomly choose between a letter or a number for the next character
		const letterOrNumber = Math.random();

		if (letterOrNumber < 0.5) {
			// Letter
			// A-Z : 65-90 (ASCII)
			const min = 65;
			const max = 90 + 1;

			code += String.fromCharCode(
				Math.floor(Math.random() * (max - min) + min)
			);
		} else {
			// Number
			// 0-9 : 48-57 (ASCII)
			const min = 48;
			const max = 57 + 1;

			code += String.fromCharCode(
				Math.floor(Math.random() * (max - min) + min)
			);
		}
	}

	return code;
};

// Company Cam
export const J2ACompanyCamID = 3441977; // Default J2 Automation Company Cam ID
